(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!window.customElements.get('lg-purchase-bar')) {
    window.customElements.define(
      'lg-purchase-bar',
      class extends HTMLElement {
        _updateVisibility() {
          var show = this._scrolledPast && !this._footerInView;
          this.classList.toggle('is-visible', show);
          document.documentElement.classList.toggle('lg-has-purchase-bar', show);
          document.body.classList.toggle('lg-has-purchase-bar', show);
          this._updateChatWidgets(show);

          var self = this;
          requestAnimationFrame(function () {
            self._updateOffset();
          });
        }

        _updateOffset() {
          var isVisible = this.classList.contains('is-visible');
          var height = 0;

          if (isVisible) {
            height = Math.round(this.getBoundingClientRect().height) || this.offsetHeight;
          }

          document.documentElement.style.setProperty('--lg-purchase-bar-height', height + 'px');
        }

        _updateChatWidgets(isVisible) {
          if (isVisible === undefined) {
            isVisible = this.classList.contains('is-visible');
          }

          var widgetConfigs = [
            { selector: '.ContactBubble', bottom: '90px' },
            { selector: '.Prompt', bottom: '70px' },
            { selector: '.appEmbed', bottom: '60px' },
            { selector: '#app-embed', bottom: '60px' },
          ];

          function queryAllIncludingShadow(root, selector) {
            var results = [];

            if (!root || typeof root.querySelectorAll !== 'function') {
              return results;
            }

            root.querySelectorAll(selector).forEach(function (el) {
              results.push(el);
            });

            root.querySelectorAll('*').forEach(function (el) {
              if (el.shadowRoot) {
                queryAllIncludingShadow(el.shadowRoot, selector).forEach(function (nested) {
                  results.push(nested);
                });
              }
            });

            return results;
          }

          function stashStyle(el, prop) {
            var key = 'lgOrig' + prop.replace(/-([a-z])/g, function (_, char) {
              return char.toUpperCase();
            });

            if (el.dataset[key] === undefined) {
              el.dataset[key] = el.style.getPropertyValue(prop);
              el.dataset[key + 'Priority'] = el.style.getPropertyPriority(prop);
            }
          }

          function restoreStyle(el, prop) {
            var key = 'lgOrig' + prop.replace(/-([a-z])/g, function (_, char) {
              return char.toUpperCase();
            });
            var value = el.dataset[key];
            var priority = el.dataset[key + 'Priority'] || '';

            if (value !== undefined) {
              if (value) {
                el.style.setProperty(prop, value, priority);
              } else {
                el.style.removeProperty(prop);
              }

              delete el.dataset[key];
              delete el.dataset[key + 'Priority'];
            }
          }

          function applyToRoot(root) {
            if (!root) return false;

            var matched = false;

            widgetConfigs.forEach(function (cfg) {
              queryAllIncludingShadow(root, cfg.selector).forEach(function (el) {
                matched = true;

                if (isVisible) {
                  stashStyle(el, 'bottom');
                  el.style.setProperty('bottom', cfg.bottom, 'important');
                  el.dataset.lgPurchaseBarOffset = 'true';
                } else if (el.dataset.lgPurchaseBarOffset) {
                  restoreStyle(el, 'bottom');
                  delete el.dataset.lgPurchaseBarOffset;
                }
              });
            });

            return matched;
          }

          function offsetIframeHost(iframe, bottom) {
            var host = iframe.parentElement;
            var depth = 0;
            var positionedHost = null;

            while (host && host !== document.body && depth < 6) {
              var position = window.getComputedStyle(host).position;

              if (position === 'fixed' || position === 'absolute') {
                positionedHost = host;
                break;
              }

              host = host.parentElement;
              depth += 1;
            }

            var target = positionedHost || iframe;

            if (isVisible) {
              stashStyle(target, 'bottom');
              target.style.setProperty('bottom', bottom, 'important');
              target.dataset.lgPurchaseBarIframeHost = 'true';
            } else if (target.dataset.lgPurchaseBarIframeHost) {
              restoreStyle(target, 'bottom');
              delete target.dataset.lgPurchaseBarIframeHost;
            }
          }

          function isLikelyChatIframe(iframe) {
            var src = (iframe.getAttribute('src') || '').toLowerCase();
            var id = (iframe.id || '').toLowerCase();
            var title = (iframe.getAttribute('title') || '').toLowerCase();
            var meta = src + ' ' + id + ' ' + title;

            if (/chat|gorgias|klaviyo|intercom|tidio|crisp|zendesk|hubspot|messenger|contact|prompt|podium/.test(meta)) {
              return true;
            }

            var rect = iframe.getBoundingClientRect();
            return rect.width > 0 && rect.width <= 420 && rect.height <= 420 && rect.bottom > window.innerHeight * 0.45;
          }

          applyToRoot(document);

          document.querySelectorAll('iframe').forEach(function (iframe) {
            if (!isLikelyChatIframe(iframe)) return;

            var appliedInside = false;

            try {
              if (iframe.contentDocument) {
                appliedInside = applyToRoot(iframe.contentDocument);
              }
            } catch (error) {
              appliedInside = false;
            }

            var isPodiumIframe = /podium/.test((iframe.getAttribute('src') || '').toLowerCase());
            var hasPodiumBubble = Boolean(document.getElementById('podium-bubble'));

            if (!appliedInside && !(hasPodiumBubble && isPodiumIframe)) {
              offsetIframeHost(iframe, '90px');
            }
          });
        }

        _watchChatWidgets() {
          if (this._chatWidgetObserver) return;

          var self = this;
          this._chatWidgetObserver = new MutationObserver(function () {
            self._updateChatWidgets(self.classList.contains('is-visible'));
          });

          this._chatWidgetObserver.observe(document.body, {
            childList: true,
            subtree: true,
          });
        }

        connectedCallback() {
          this._sentinel = document.querySelector('.lg-purchase-panel-sentinel');
          this._footer = document.querySelector('.shopify-section--footer');
          this._scrolledPast = false;
          this._footerInView = false;

          this._observer = new IntersectionObserver(this._onIntersect.bind(this), {
            threshold: [0, 1],
          });

          if (this._sentinel) {
            this._observer.observe(this._sentinel);
          }

          if (this._footer) {
            this._observer.observe(this._footer);
          }

          this._resizeObserver = new ResizeObserver(
            function () {
              this._updateOffset();
              if (this.classList.contains('is-visible')) {
                this._updateChatWidgets(true);
              }
            }.bind(this)
          );
          this._resizeObserver.observe(this);

          this._bindVariantProxy();
          this._watchChatWidgets();
          this._updateVisibility();
        }

        disconnectedCallback() {
          this._observer?.disconnect();
          this._resizeObserver?.disconnect();
          this._chatWidgetObserver?.disconnect();
          document.documentElement.classList.remove('lg-has-purchase-bar');
          document.body.classList.remove('lg-has-purchase-bar');
          document.documentElement.style.removeProperty('--lg-purchase-bar-height');
          this._updateChatWidgets(false);
        }

        _onIntersect(entries) {
          entries.forEach(function (entry) {
            if (entry.target === this._sentinel) {
              this._scrolledPast = entry.boundingClientRect.top < 0;
            }

            if (entry.target === this._footer) {
              this._footerInView = entry.isIntersecting;
            }
          }, this);

          this._updateVisibility();
        }

        _bindVariantProxy() {
          var formId = this.getAttribute('form');
          if (!formId) return;

          this.addEventListener('click', function (event) {
            var variantBtn = event.target.closest('.lg-purchase-bar__variant:not(.is-disabled)');
            if (!variantBtn || !this.contains(variantBtn)) return;

            var value = variantBtn.dataset.lgVariantValue;
            var input = document.querySelector('input[form="' + formId + '"][value="' + value + '"]');

            if (input && !input.checked) {
              input.click();
            }
          }.bind(this));
        }
      }
    );
  }

  if (!prefersReducedMotion.matches) {
    document.addEventListener(
      'pointerdown',
      function (event) {
        var swatch = event.target.closest(
          '.product-info--lg-recliner .thumbnail-swatch, .product-info--lg-recliner .block-swatch, .lg-purchase-bar__variant'
        );
        if (!swatch) return;

        var previousSwatch = null;

        if (swatch.classList.contains('lg-purchase-bar__variant')) {
          if (swatch.classList.contains('is-selected')) return;
          previousSwatch = swatch.closest('.lg-purchase-bar__variants')?.querySelector('.lg-purchase-bar__variant.is-selected');
        } else {
          var swatchId = swatch.getAttribute('for');
          var swatchInput = swatchId ? document.getElementById(swatchId) : null;
          if (!swatchInput || swatchInput.checked) return;

          var option = swatch.closest('.variant-picker__option');
          previousSwatch = option?.querySelector(
            'input[data-option-position]:checked + .thumbnail-swatch, input[data-option-position]:checked + .block-swatch'
          );
        }

        if (!previousSwatch || previousSwatch === swatch) return;

        previousSwatch.classList.add('lg-variant-swatch--deselecting');

        function onTransitionEnd(transitionEvent) {
          if (transitionEvent.target !== previousSwatch) return;
          if (transitionEvent.propertyName !== 'border-color' && transitionEvent.propertyName !== 'box-shadow') return;

          previousSwatch.classList.remove('lg-variant-swatch--deselecting');
          previousSwatch.removeEventListener('transitionend', onTransitionEnd);
        }

        previousSwatch.addEventListener('transitionend', onTransitionEnd);
      },
      true
    );
  }

  var section = document.querySelector('.lg-feat');
  if (!section) return;

  var desktopMQ = window.matchMedia('(min-width: 769px)');
  var videos = section.querySelectorAll('video.lg-feat__video');
  var heroVideo = section.querySelector('.lg-feat__video--hero');

  function setHeroSource() {
    if (!heroVideo) return;

    var src = desktopMQ.matches ? heroVideo.dataset.desktopSrc : heroVideo.dataset.mobileSrc;
    var poster = desktopMQ.matches ? heroVideo.dataset.desktopPoster : heroVideo.dataset.mobilePoster;
    var sourceEl = heroVideo.querySelector('source');

    if (sourceEl && src) {
      sourceEl.src = src;
    }

    if (poster) {
      heroVideo.poster = poster;
    }

    heroVideo.load();

    if (!prefersReducedMotion.matches) {
      heroVideo.play().catch(function () {});
    }
  }

  if (heroVideo) {
    setHeroSource();
    desktopMQ.addEventListener('change', setHeroSource);
  }

  if (prefersReducedMotion.matches) {
    videos.forEach(function (video) {
      video.removeAttribute('autoplay');
      video.pause();
    });
  } else if (videos.length) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.intersectionRatio >= 0.25) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: [0, 0.25] }
    );

    videos.forEach(function (video) {
      observer.observe(video);
      video.play().catch(function () {});
    });
  }

  var mobileMQ = window.matchMedia('(max-width: 768px)');

  function initSlider(slider) {
    if (slider.dataset.lgFeatSliderInit === 'true') return;
    slider.dataset.lgFeatSliderInit = 'true';

    var slides = slider.querySelectorAll('.lg-feat__slide');
    var counter = slider.querySelector('[data-lg-feat-counter]');
    var prevBtn = slider.querySelector('.lg-feat__prev');
    var nextBtn = slider.querySelector('.lg-feat__next');
    var total = slides.length;
    var current = 0;
    var timer = null;
    var paused = false;
    var delay = parseInt(slider.dataset.autoplay, 10) || 5000;

    if (!total) return;

    function updateCounter() {
      if (counter) {
        counter.textContent = String(current + 1) + ' / ' + String(total);
      }
    }

    function goTo(index) {
      current = (index + total) % total;
      slides.forEach(function (slide, i) {
        if (i === current) {
          slide.removeAttribute('hidden');
        } else {
          slide.setAttribute('hidden', '');
        }
      });
      updateCounter();
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (prefersReducedMotion.matches || paused || !mobileMQ.matches) return;
      timer = setInterval(next, delay);
    }

    function resetAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    prevBtn.addEventListener('click', function () {
      prev();
      resetAutoplay();
    });

    nextBtn.addEventListener('click', function () {
      next();
      resetAutoplay();
    });

    slider.addEventListener('mouseenter', function () {
      paused = true;
      stopAutoplay();
    });

    slider.addEventListener('mouseleave', function () {
      paused = false;
      startAutoplay();
    });

    slider.addEventListener('focusin', function () {
      paused = true;
      stopAutoplay();
    });

    slider.addEventListener('focusout', function (event) {
      if (!slider.contains(event.relatedTarget)) {
        paused = false;
        startAutoplay();
      }
    });

    slider._lgFeatStopAutoplay = stopAutoplay;
    slider._lgFeatStartAutoplay = startAutoplay;

    goTo(0);
    startAutoplay();
  }

  function initMobileSliders() {
    section.querySelectorAll('[data-lg-feat-slider]').forEach(initSlider);
  }

  function teardownMobileSliders() {
    section.querySelectorAll('[data-lg-feat-slider]').forEach(function (slider) {
      if (slider._lgFeatStopAutoplay) {
        slider._lgFeatStopAutoplay();
      }
    });
  }

  if (mobileMQ.matches) {
    initMobileSliders();
  }

  mobileMQ.addEventListener('change', function (event) {
    if (event.matches) {
      initMobileSliders();
      section.querySelectorAll('[data-lg-feat-slider]').forEach(function (slider) {
        if (slider._lgFeatStartAutoplay) {
          slider._lgFeatStartAutoplay();
        }
      });
    } else {
      teardownMobileSliders();
    }
  });

  function initRevealAnimations() {
    var revealTargets = section.querySelectorAll(
      '.lg-feat__title, .lg-feat__bleed, .lg-feat__row, .lg-feat__3d-inner, .lg-feat__cta'
    );

    revealTargets.forEach(function (el) {
      if (el.classList.contains('lg-feat__title--white')) return;

      el.classList.add('lg-feat__reveal');

      if (el.classList.contains('lg-feat__row')) {
        if (el.dataset.text === 'right') {
          el.classList.add('lg-feat__reveal--right');
        } else {
          el.classList.add('lg-feat__reveal--left');
        }
      }
    });

    if (prefersReducedMotion.matches) {
      section.querySelectorAll('.lg-feat__reveal').forEach(function (el) {
        el.classList.add('lg-feat__reveal--in');
      });
      return;
    }

    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('lg-feat__reveal--in');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -5% 0px' }
    );

    section.querySelectorAll('.lg-feat__reveal').forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  initRevealAnimations();

  section.querySelectorAll('[data-lg-feat-scroll-top]').forEach(function (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      var purchaseSection = document.querySelector('.shopify-section--main-product');

      if (purchaseSection) {
        purchaseSection.scrollIntoView({ behavior: prefersReducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      } else {
        window.scrollTo({ top: 0, behavior: prefersReducedMotion.matches ? 'auto' : 'smooth' });
      }
    });
  });

  document.querySelectorAll('[data-lg-feat-scroll-next]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var nextSection =
        document.querySelector('.shopify-section--lg-recliner-features') ||
        document.querySelector('.shopify-section--main-product')?.nextElementSibling;

      if (nextSection) {
        nextSection.scrollIntoView({ behavior: prefersReducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      }
    });
  });
})();
